import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";


const EditUser = () => {
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [email, setEmail] = useState("");
  const [membership, setMembership] = useState("");
  const [memberplan, setMemberplan] = useState("");
  const [isPending, setIsPending] = useState(false);
  const [loading, setLoading] = useState(true);

  const { id } = useParams();
  const history = useHistory()

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/admin/user/${id}`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        console.log("data:", data);
        setFirst_name(data.msg.first_name);
        setLast_name(data.msg.last_name);
        setEmail(data.msg.email);
        setMembership(data.msg.membership);
        setMemberplan(data.msg?.memberplan);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const blog = { first_name, last_name, membership, email, memberplan };

    setIsPending(true);

    fetch(`${process.env.REACT_APP_BASE_URL}/admin/user/${id}`, {
      method: "PUT",
      body: JSON.stringify(blog),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((data) => data.json())
      .then((res) => {
        // console.log("res", res);
        setIsPending(false);
        history.push("/dashboard/all-users");
      });
  };

  if (loading) {
    return (
      <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
        <div className="lds-dual-ring"></div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-11 m-auto">
          <div className="add-page mt-3">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <h3>
                      <i className="fa fa-plus"></i> Edit User
                    </h3>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="datails-content">
                      <label>First Name</label>
                      <input
                        type="text"
                        placeholder="First Name"
                        value={first_name}
                        onChange={(e) => setFirst_name(e.target.value)}
                      />
                    </div>
                    <div className="datails-content">
                      <label>Last Name</label>
                      <input
                        type="text"
                        placeholder="Last Name"
                        value={last_name}
                        onChange={(e) => setLast_name(e.target.value)}
                      />
                    </div>
                    <div className="datails-content">
                      <label>Email</label>
                      <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    <div className="datails-content">
                      <label>Membership</label>
                      <select
                        onChange={(e) => {
                          setMembership(e.target.value);
                        }}
                        value={membership}
                      >
                        <option value=""></option>
                        <option value="premiumPlan">Premium</option>
                        <option value="freePlan">Free</option>
                      </select>
                    </div>

                    <div className="datails-content">
                      <label>Membership Type</label>
                      {membership === "freePlan" ? (
                        <input disabled className="dis" />
                      ) : (
                        <select
                          onChange={(e) => {
                            setMemberplan(e.target.value);
                          }}
                          value={memberplan}
                        >
                          <option value=""></option>
                          <option value="Monthly">Monthly</option>
                          <option value="Biannual">Biannual</option>
                          <option value="Annual">Annual</option>
                        </select>
                      )}
                    </div>

                    <button className="contButSmall" type={"submit"}>
                      {isPending ? "Saving..." : "Save"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
